import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserIcon, LockIcon, ArrowRightIcon, Loader2Icon, AlertCircleIcon } from 'lucide-react';
import { useMunicipality } from '../hooks/useMunicipality';
const VALID_USERS: Record<string, string> = {
  // Admin: 'Admin',
  // PnpScada: 'PnpScada',
  Sondlane: 'Sondlane',
  Support: 'Support',
  Nyamezela: 'Nyamezela'
};
export function Login() {
  const {
    selected: municipality
  } = useMunicipality();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    setTimeout(() => {
      const expectedPassword = VALID_USERS[formData.username];
      if (expectedPassword && expectedPassword === formData.password) {
        setIsLoading(false);
        navigate('/launch');
      } else {
        setIsLoading(false);
        setError('Invalid username or password. Please try again.');
      }
    }, 1200);
  };
  return <div className="fixed inset-0 z-50 bg-gray-50 flex flex-col justify-center items-center py-12 px-4 sm:px-6 lg:px-8 animate-in fade-in duration-500 overflow-y-auto" data-id="element-1299">
      {/* Header / Logo */}
      <div className="flex flex-col items-center mb-8 text-center" data-id="element-1300">
        <div className="bg-white p-6 rounded-none mb-6 border border-gray-100 flex items-center gap-6" data-id="element-1301">
          {/* <img
            src="/sondlane_nyamezela_logo.svg"
            alt="Sondlane Nyamezela Logo"
            className="h-48 w-auto object-contain" /> */}

          <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/s5dgpz2pomohbgjmvchnas/19620cb4-f500-4d30-868d-0c11080a1184/mavis_letters_logo_2.svg" alt="MAVIS Logo" className="h-48 w-auto object-contain" data-id="element-1302" />

        </div>
        <h1 className="text-3xl font-bold text-gray-900 tracking-tight mb-2" data-id="element-1303">
           Sign in to MAVIS
          </h1>
          <p className="text-sm text-gray-500 max-w-sm" data-id="element-1304">
           Municipal Advanced Vending Infrastructure System
          </p>
      </div>

      {/* Login Card */}
      <div className="w-full max-w-md bg-white border border-gray-200 shadow-lg rounded-none p-8 relative overflow-hidden" data-id="element-1305">
        {/* Top accent border */}
        <div className="absolute top-0 left-0 right-0 h-1" style={{
        backgroundColor: municipality.accentColor
      }} data-id="element-1306" />


        {/* Error Message */}
        {error && <div className="mb-6 flex items-center gap-2 p-3 bg-red-50 border border-red-200 text-red-700 text-sm rounded-none animate-in fade-in slide-in-from-top-2 duration-300" data-id="element-1307">
            <AlertCircleIcon className="w-4 h-4 shrink-0" data-id="element-1308" />
            {error}
          </div>}

        <form onSubmit={handleSubmit} className="space-y-6" data-id="element-1309">
          <div data-id="element-1310">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1311">
              Username
            </label>
            <div className="relative" data-id="element-1312">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1313">
                <UserIcon className="h-5 w-5 text-gray-400" data-id="element-1314" />
              </div>
              <input type="text" required value={formData.username} onChange={e => {
              setFormData({
                ...formData,
                username: e.target.value
              });
              setError('');
            }} className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-none focus:ring-2 focus:ring-opacity-50 focus:border-transparent transition-colors text-sm" style={{
              '--tw-ring-color': municipality.accentColor
            } as React.CSSProperties} placeholder="Enter your username" disabled={isLoading} data-id="element-1315" />

            </div>
          </div>

          <div data-id="element-1316">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1317">
              Password
            </label>
            <div className="relative" data-id="element-1318">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1319">
                <LockIcon className="h-5 w-5 text-gray-400" data-id="element-1320" />
              </div>
              <input type="password" required value={formData.password} onChange={e => {
              setFormData({
                ...formData,
                password: e.target.value
              });
              setError('');
            }} className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-none focus:ring-2 focus:ring-opacity-50 focus:border-transparent transition-colors text-sm" style={{
              '--tw-ring-color': municipality.accentColor
            } as React.CSSProperties} placeholder="••••••••" disabled={isLoading} data-id="element-1321" />

            </div>
          </div>

          <div className="flex items-center justify-between" data-id="element-1322">
            <div className="flex items-center" data-id="element-1323">
              <input id="remember-me" name="remember-me" type="checkbox" className="h-4 w-4 rounded-none border-gray-300 text-mavis-teal focus:ring-mavis-teal cursor-pointer" style={{
              color: municipality.accentColor
            }} data-id="element-1324" />


              <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-700 cursor-pointer" data-id="element-1325">

                Remember me
              </label>
            </div>

            <div className="text-sm" data-id="element-1326">
              <a href="#" className="font-medium hover:underline transition-colors" style={{
              color: municipality.accentColor
            }} data-id="element-1327">

                Forgot password?
              </a>
            </div>
          </div>

          <button type="submit" disabled={isLoading} className="w-full flex justify-center items-center py-3 px-4 border border-transparent rounded-none shadow-sm text-sm font-medium text-white transition-all hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-70 disabled:cursor-not-allowed" style={{
          backgroundColor: municipality.accentColor,
          '--tw-ring-color': municipality.accentColor
        } as React.CSSProperties} data-id="element-1328">

            {isLoading ? <Loader2Icon className="w-5 h-5 animate-spin" data-id="element-1329" /> : <>
                Sign in
                <ArrowRightIcon className="ml-2 w-4 h-4" data-id="element-1330" />
              </>}
          </button>
        </form>
      </div>

      {/* Footer */}
      <div className="mt-12 text-center" data-id="element-1331">
        <p className="text-xs text-gray-400" data-id="element-1332">
          &copy; {new Date().getFullYear()} Sondlane Telecoms (PTY) Ltd. All
          rights reserved.
        </p>
        <div className="mt-2 flex justify-center space-x-4 text-xs text-gray-400" data-id="element-1333">
          <a href="#" className="hover:text-gray-600 transition-colors" data-id="element-1334">
            Privacy Policy
          </a>
          <span data-id="element-1335">&middot;</span>
          <a href="#" className="hover:text-gray-600 transition-colors" data-id="element-1336">
            Terms of Service
          </a>
          <span data-id="element-1337">&middot;</span>
          <a href="#" className="hover:text-gray-600 transition-colors" data-id="element-1338">
            Support
          </a>
        </div>
      </div>
    </div>;
}